import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import managerService from '../services/managerService';

export const getAnalytics = createAsyncThunk('manager/getAnalytics', async () => {
  const analytics = await managerService.getAnalytics();

  return analytics;
});

const INITIAL_STATE = { analytics: null, isLoading: false, isError: false, errorMessage: null };

export const managerSlice = createSlice({
  name: 'manager',
  initialState: { ...INITIAL_STATE },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAnalytics.fulfilled, (state, action) => {
        // Add user to the state array
        state.analytics = action.payload;
        state.isLoading = false;
        state.isError = false;
        state.errorMessage = null;
      })
      .addCase(getAnalytics.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = null;
      })
      .addCase(getAnalytics.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = null;
      })
      .addCase('signOutGlobally', () => ({ ...INITIAL_STATE }));
  }
});

export default managerSlice.reducer;
